import React,{ useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector} from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import {  SECONDORY_COLOR } from "../common/sharedFunctions";
export default function Earningreports() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  
  const settings = useSelector(state => state.settingsdata.settings);

    const columns =  [
        { title: t('year'),field: 'year',
        },
        { title: t('months'), field: 'monthsName', 
      },
        { title: t('booking_count'), field: 'total_rides',
        },
        { title: t('Gross_trip_cost'),  render: rowData => (parseFloat(rowData.tripCost) + parseFloat(rowData.cancellationFee)).toFixed(settings.decimal) , editable:'never',
        
        },
        { title: t('trip_cost_driver_share'), field: 'rideCost', 
        
      },
        { title: t('cancellationFee'), field: 'cancellationFee', 
     
      },
        { title: t('convenience_fee'), field: 'convenienceFee', 
        
      },
        { title: t('latra_levy'), field: 'latraLevy',
        
      },
        { title: t('admin_fees'), field: 'adminFees',
        
      },
        { title: t('Discounts'), field: 'discountAmount', 
        
      },
        { title: t('Profit'),  render: rowData => (parseFloat(rowData.convenienceFee) + parseFloat(rowData.cancellationFee) - parseFloat(rowData.discountAmount)).toFixed(settings.decimal) , editable:'never',
        
        },
    ];

  const [data, setData] = useState([]);
  const earningreportsdata = useSelector(state => state.earningreportsdata);

  useEffect(()=>{
        if(earningreportsdata.Earningreportss){
            setData(earningreportsdata.Earningreportss);
        }
  },[earningreportsdata.Earningreportss]);

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    earningreportsdata.loading? <CircularLoading/>:
    <MaterialTable
      title={t('earning_reports_title')}
      columns={columns}
      style={{
        direction: isRTL === "rtl" ? "rtl" : "ltr",
        borderRadius: "8px",
        boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
        border: "1px solid rgba(224, 224, 224, 1)",
        padding: "20px",
        backgroundColor: 'white',
        width: '100%',
        overflowX: 'auto'
      }}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={{
        pageSize: 10,
        pageSizeOptions: [10, 15, 20],
        exportButton: true,
        maxColumnSort: "all_columns",
        rowStyle: rowData => ({
          backgroundColor: selectedRow === rowData.tableData.id ? "#F5F5F5" : "white",
          border: "1px solid rgba(224, 224, 224, 1)",
          transition: 'background-color 0.2s ease',
          '&:hover': {
            backgroundColor: '#F5F5F5',
            cursor: 'pointer'
          }
        }),
        editable:{
          backgroundColor: colors.Header_Text,
          fontSize: "0.8em",
          fontWeight: "bold",
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        },
        headerStyle: {
          position: "sticky",
          top: "0px",
          backgroundColor: "#0811ae",
          textAlign: "center",
          fontSize: "0.9em",
          fontWeight: "bold",
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          border: "1px solid rgba(224, 224, 224, 1)",
          color: 'white',
          padding: '12px 8px',
          whiteSpace: 'nowrap'
        },
        cellStyle: {
          border: "1px solid rgba(224, 224, 224, 1)",
          textAlign: "center",
          padding: '12px 8px',
          fontSize: '0.9em',
          whiteSpace: 'nowrap'
        },
        actionsColumnIndex: -1,
        searchFieldStyle: {
          fontSize: '0.9em',
          padding: '8px',
          margin: '8px 0'
        },
        searchFieldVariant: 'outlined',
        toolbarButtonAlignment: 'right',
        showTitle: true,
        draggable: false,
        emptyRowsWhenPaging: false,
        minBodyHeight: '400px',
        tableLayout: 'auto',
        thirdSortClick: false,
        padding: 'dense'
      }}
      localization={{
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        pagination: {
          labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
          firstTooltip: (t('first_page_tooltip')),
          previousTooltip: (t('previous_page_tooltip')),
          nextTooltip: (t('next_page_tooltip')),
          lastTooltip: (t('last_page_tooltip'))
        },
      }}
      
    />
  );
}
